import React, { useEffect, useRef, useState } from "react";
import GLOBALS from "../../globals";

// COMPONENTS
import Layout from "../layout/Layout";
import Title from "../text/Title";
import NewButton from "../buttons/NewButton";

const Modal = ({
  title,
  text,
  buttons,
  visible,
  loader,
  closeModal,
  focusedElBeforeModalID,
  oldTemplateDesign,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [toggleLoader, setToggleLoader] = useState(false);
  const focusableElms = useRef(null);
  let focusedEl = 0;

  const modalBack = useRef();
  const container = useRef();
  let wrapDimensions = null;

  useEffect(() => {
    // get width and height of the modal container
    // if (modalWrap.current && !ModalData.modalDimensions) {
    //   const dim = modalWrap.current.getBoundingClientRect();
    //   ModalData.modalDimensions = { width: `${dim.width}px`, height: `${dim.height}px` };
    // }

    // select all focusable elements
    focusableElms.current = GLOBALS.getDomEl('[data-focusable="modalel"]', true);
  });

  // toggle content/loader
  // useEffect(() => {
  //   // if loader is true, show the loader
  //   if (loader) {
  //     setToggleLoader(true);
  //   }

  //   // if laoder is false, close the modal after animation
  //   // and hide the loader
  //   if (loader === false) {
  //     timer = setTimeout(() => {
  //       clearTimeout(timer);
  //       setIsVisible(false);
  //       setToggleLoader(false);
  //     }, 500);
  //   }

  //   // apply modals container dimensions to the loader container
  //   if (loader && loaderWrap.current) {
  //     loaderWrap.current.style.width = ModalData.modalDimensions.width;
  //     loaderWrap.current.style.height = ModalData.modalDimensions.height;
  //   }
  // }, [loader]);

  // toggle modal
  useEffect(() => {
    if (visible) {
      setIsVisible(true);
    } else {
      // hide the modal
      setIsVisible(false);
      setToggleLoader(false);
    }
  }, [visible]);

  useEffect(() => {
    // focus content container on load
    if (container.current) {
      container.current.focus();
    }

    // fade in modal
    if (isVisible) {
      if (modalBack.current) modalBack.current.classList.remove("__mo_i");
    }
  }, [isVisible]);

  // unmount
  useEffect(() => {
    return () => {
      // focus last focused element before the modal
      if (focusedElBeforeModalID && GLOBALS.getDomEl(`[data-focusid="${focusedElBeforeModalID}"]`))
        GLOBALS.getDomEl(`[data-focusid="${focusedElBeforeModalID}"]`).focus();
    };
  });

  // const sppiner = done => {
  //   return (
  //     <div ref={loaderWrap} data-test="modalLoader">
  //       <Layout flex alignItemsCenter justifyContentCenter textAlignCeter fullHeight>
  //         <CheckLoader done={done} />
  //       </Layout>
  //     </div>
  //   );
  // };

  const handleTabPress = e => {
    let keyCode = e.which || e.keyCode;

    // trap focus inside of modal
    if (keyCode === 9) {
      e.preventDefault();

      if (focusableElms.current.length > 0) {
        if (focusableElms.current[focusedEl]) focusableElms.current[focusedEl].focus();

        if (focusedEl >= focusableElms.current.length - 1) {
          focusedEl = 0;
        } else {
          focusedEl = focusedEl + 1;
        }
      }
    }

    // close modal on Esc
    if (keyCode === 27) {
      close();
    }
  };

  const close = () => {
    if (closeModal) closeModal();
  };

  if (!isVisible) return null;
  return (
    <div
      className={`__mo_p  ${oldTemplateDesign ? "__mo_o" : ""} __mo_i`}
      onClick={close}
      data-test="modalBack"
      data-component_name="Modal"
      ref={modalBack}
      style={{ transition: "opacity .5s ease-in-out" }}
    >
      <div
        className="__mo_c bc12"
        data-test="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modalLabel_410392"
        // ref={modalWrap}
        style={wrapDimensions}
        onKeyDown={handleTabPress}
        data-focusedelbeforemodal={focusedElBeforeModalID}
      >
        {!toggleLoader && (
          <div
            data-test="content"
            tabIndex="0"
            className="focused_354"
            style={{ outline: "none" }}
            ref={container}
          >
            <div data-test="header"></div>

            <div className="__mo_b" data-test="body">
              {title && <Title id="modalLabel_410392">{title}</Title>}
              <p data-test="text">{text}</p>
              <div data-test="buttons" className="__mo_bb">
                <Layout flex spaceEvenly>
                  {buttons &&
                    buttons.map(button => (
                      <NewButton focusableId="modalel" key={button.id} {...button} />
                    ))}
                </Layout>
              </div>
            </div>

            <div data-test="footer"></div>
          </div>
        )}
        {/* {loader ? sppiner(loader) : sppiner(loader)} */}
      </div>
    </div>
  );
};

export default Modal;
